export type TDataCategory = { key: string, value: string }

export function categoryList(data: TDataCategory[], depth = 0): TDataCategory[] {


    return data.map((item) => {
        let kk = {
            key: "",
            value: ""
        };
        let keyNew = item.key.split('.');
        if (!depth) {
            kk.value = keyNew[0]
        } else {
            kk.value = keyNew[depth];
            if (keyNew[depth] == undefined) {
                kk.value = keyNew[(keyNew.length) - 1]
            }
        }

        kk.key = keyNew.join('.');
        return kk
    });

}






